import {replaceItem, removeItem} from '../../../common/util/array';

const BASE_NEW_ORDER = {
  'process': 'insert',
  'partCode': '',
  'partQuantity': 1,
  'unitFob': 0,
  'totalFob': 0,
  'rejectionCode': '?',
  'rejectionDescription': 'Desconocido',
  'ICC': '',
  'scc': '',
};

export const getOrderCode = (orders) => {
  return !orders.length ? '' : orders[0].orderCode;
};

export const getOrderProcess = (previousProcess, newProcess) => {
  if (previousProcess === 'insert' || previousProcess === 'updateCode') {
    return previousProcess;
  }

  return newProcess;
};

export const calculateTotalFob = (quantity = 0, fob = 0) => {
  return (Number(fob) * parseInt(quantity, 10)).toFixed(2);
};

export const updatePartCode = (orders, {value, order}) => {
  const {partCode, orderCode} = order;
  const index = orders.findIndex((item) => item.partCode === partCode && item.orderCode === orderCode);
  const newProcess = getOrderProcess(order.process, 'updateCode');
  const updatedOrder = {...order,
    'partCode': value,
    'oldCode': order.oldCode || order.partCode,
    'process': newProcess,
    'verified': false,
  };
  
  return replaceItem(orders, index, updatedOrder);
};

export const updateOrderQuantity = (orders, {value, order}) => {
  const {partCode, orderCode} = order;
  const index = orders.findIndex((item) => item.partCode === partCode && item.orderCode === orderCode);
  const newProcess = getOrderProcess(order.process, 'updateQuantity');
  const updatedOrder = {...order,
    'partQuantity': value,
    'totalFob': calculateTotalFob(value, order.unitFob),
    'process': newProcess,
  };

  return replaceItem(orders, index, updatedOrder);
};

export const addOrderElement = (state) => {
  const {suggestedOrders, filteredOrders} = state;
  const ordersCount = suggestedOrders.length;
  
  if (!ordersCount || !suggestedOrders[ordersCount - 1].partCode) {
    return {suggestedOrders, filteredOrders};
  }

  return {
    'suggestedOrders': [...suggestedOrders, BASE_NEW_ORDER],
    'filteredOrders': [...filteredOrders, BASE_NEW_ORDER],
  };
};

export const removeOrderElement = (orders, {partCode, orderCode}) => {
  const orderIndex = orders.findIndex((order) => order.partCode === partCode && order.orderCode === orderCode);

  return removeItem(orders, orderIndex);
};

export const toggleDeleteMark = (orders, selectedOrder) => {
  const orderIndex = orders.findIndex((order) =>
    order.partCode === selectedOrder.partCode && order.lineNumber === selectedOrder.lineNumber);
  const updatedElement = {...orders[orderIndex], 'deleted': !orders[orderIndex].deleted};

  return replaceItem(orders, orderIndex, updatedElement);
};

export const filterCurrentOrders = (orders, {iccFilter, sccFilter, partCodeFilter, obsFilter}) => {
  return orders.filter((order) => {
    return order.ICC && order.ICC.startsWith(iccFilter) && order.scc && order.scc.startsWith(sccFilter) && order.scc &&
      order.partCode.startsWith(partCodeFilter) && order.obs.startsWith(obsFilter);
  });
};

const moveFromSpecialToSuggested = (state, order, specialOrder) => {
  const {suggestedOrders, filteredOrders, specialOrders} = state;
  const ordersCount = suggestedOrders.length;

  if (!ordersCount) {
    return {suggestedOrders, filteredOrders, specialOrders};
  }

  const specialOrderIndex = specialOrders.findIndex((element) => element.orderSequence === specialOrder.orderSequence);
  const newOrder = {
    ...order,
    'process': 'insert',
    'partQuantity': specialOrder.partQuantity,
    'special': true,
    'verified': true,
  };

  if (suggestedOrders[ordersCount - 1].partCode) {
    return {
      'suggestedOrders': [...suggestedOrders, newOrder],
      'filteredOrders': [...filteredOrders, newOrder],
      'specialOrders': removeItem(specialOrders, specialOrderIndex),
    };
  }

  return {
    'suggestedOrders': replaceItem(suggestedOrders, suggestedOrders.length - 1, newOrder),
    'filteredOrders': replaceItem(filteredOrders, filteredOrders.length - 1, newOrder),
    'specialOrders': removeItem(specialOrders, specialOrderIndex),
  };
};

const updateVerifiedOrderCode = (orders, verification, orderCode) => {
  const index = orders.findIndex((order) =>
    order.partCode === verification.partCode && order.orderCode === orderCode);
  const verifiedOrder = {...orders[index], ...verification, 'verified': true};

  return replaceItem(orders, index, verifiedOrder);
};

export const processCodeVerification = (state, verification, payload) => {
  const {order} = payload;
  
  switch (payload.type) {
    case 'move':
      return {
        ...state,
        ...moveFromSpecialToSuggested(state, verification, order),
        'checkingCode': false,
        'verifying': false,
      };
    case 'update':
      return {
        ...state,
        'checkingCode': false,
        'verifying': false,
        'suggestedOrders': updateVerifiedOrderCode(state.suggestedOrders, verification, order.orderCode),
        'filteredOrders': updateVerifiedOrderCode(state.filteredOrders, verification, order.orderCode),
      };
    default:
      return {...state, 'checkingCode': false, 'verifying': false};
  }
};

const compareSortingValues = (value1, value2, direction) => {
  if (value1 > value2) {
    return direction === 'ascending' ? 1 : -1;
  }

  if (value1 < value2) {
    return direction === 'ascending' ? -1 : 1;
  }

  return 0;
};

export const sortSuggestedOrder = (orders, {key, direction}) => {
  const sortedOrders = [...orders];
  sortedOrders.sort((order1, order2) => {
    if (!order2.partCode || order2.unitFob === 0) {
      return -1;
    }
    return compareSortingValues(order1[key], order2[key], direction);
  });

  return sortedOrders;
};
